<script>
    import {dataTablesAction} from '../components/data-tables-action.js';
    import Spinner from "./components/spinner.svelte";
    import wrappedFetch from "../wrappedFetch.js";
    import DataTable from "../components/data-table.svelte";
    import Card from './components/card.svelte';
    
    export let reportData=[];

    let isPageLoading = true;
    let columnDefs = [{ type: 'date-euro', targets: [4,5] }];
    let order = [[5, "desc"]]
    let Type = "import";

    export let detailsFor = "";
    const getTableConfig = (data)=> {
        return {data:data,config: {"paging": false,"info": false,"searching": false, dom: 'lfBrtip', buttons: ['excelHtml5',{extend:'csvHtml5'}], "order": [[1, "asc"]]}};        
    }

    export const getImportData = async()=>{
        isPageLoading = true;
            let resp = await wrappedFetch('/api/admin/GetImportDataReport', {
            method: "post",
        });
        reportData = await resp.json();        
        isPageLoading = false;
        Type = "import";
    }

    export const getExportData = async()=>{
        isPageLoading = true;
        let resp = await wrappedFetch('/api/admin/GetExportDataReport', {
            method: "post",
        });
        reportData = await resp.json();        
        isPageLoading = false;
        Type = "export";
        
        columnDefs = [{ type: 'date-euro', targets: [4,5,6] }];
        order = [[5, "desc"]]
    }
</script>

{#if isPageLoading}
    <Spinner/>
{:else}
    <Card>
        <div slot="body">
            <DataTable {columnDefs} {order} ResponsiveHeader='1' DataLength={reportData.length}>
                <thead>
                    <tr>             
                        <th>DfE code</th>
                        <th>School </th>
                        <th>Authority</th>
                        <th>{#if detailsFor == "export"}Platform {:else}MIS{/if}</th>
                        <th>Set Up </th>
                        {#if Type=="import"}
                            <th>Last Import</th>
                        {:else}
                            <th>Last Import Start</th>
                            <th>Last Import End</th>
                        {/if}
                        <th>Staff</th>
                        <th>Students</th>
                        <th>LGfL/TrustNet</th>
                        <!-- {#if detailsFor == "export"}  <th>Groups</th>{/if} -->
                    </tr>
                </thead>
                <tbody>
                    {#each reportData as data}
                        <tr>
                        
                            <td>{data.dfes || ''}</td>
                            <td>{data.schoolName || ''}</td>
                            <td>{data.authority}</td>
                            <td>{data.mis || ''}</td>
                            <td>{Date.parse(data.strSetupDt) == "978307200000" ? '' : data.strSetupDt}</td>
                            {#if Type=="import"}
                                <td>{Date.parse(data.strLastImportDt) == "978307200000" ? '' : data.strLastImportDt}</td>
                            {:else}
                                <td>{Date.parse(data.strLastImportStartDt) == "978307200000" ? '' : data.strLastImportStartDt}</td>
                                <td>{Date.parse(data.strLastImportEndDt) == "978307200000" ? '' : data.strLastImportEndDt}</td>
                            {/if}
                            <td>{data.staff_No || ''}</td>
                            <td>{data.pupil_No || ''}</td>
                            <td>{data.conType || ''}</td>
                            <!-- {#if detailsFor == "export"}  <td>0</td>{/if} -->
                        </tr>
                    {/each}
                </tbody>
            </DataTable>
        </div>
    </Card>
{/if}


